/**
 * Secret Configuration (Example/Template)
 * 
 * Copy this file to secret.ts and customize the values:
 *   cp secret.example.ts secret.ts
 * 
 * SECURITY WARNING:
 * - Never commit secret.ts with real values to Git
 * - Change SUPER_ADMIN_PATH to a random, unguessable string
 * - Only share the super admin URL with super admins via secure channel
 */

// Super Admin secret path — loaded from environment variable.
// In production, REACT_APP_SUPER_ADMIN_PATH must be set.
// In development, a safe dev-only fallback is used.
export const SUPER_ADMIN_PATH: string = process.env.REACT_APP_SUPER_ADMIN_PATH || (() => {
    if (process.env.NODE_ENV === 'production') {
        console.error('REACT_APP_SUPER_ADMIN_PATH is not set! Super-admin access is disabled.');
        return '__disabled__';
    }
    return 'sa-dev-local-only';
})();

// Full URL for super admin access
export const getSuperAdminUrl = () => `/${SUPER_ADMIN_PATH}`;

// Check if current path is super admin
export const isSuperAdminPath = (pathname: string) => pathname.startsWith(`/${SUPER_ADMIN_PATH}`);
